import React from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const DeleteRoleConfirmModal = ({ open, onClose, onConfirm, userCount }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <Box sx={{ p: 4, textAlign: 'center', position: 'relative' }}>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 10, top: 10, backgroundColor: '#D6E7FB' }}
        >
          <CloseIcon />
        </IconButton>

        <ErrorOutlineIcon sx={{ fontSize: 60, color: '#ff4d4f' }} />

        <Typography fontWeight={600} mb={1}>
          Are you sure you want to delete this role ?
        </Typography>

        <Typography color="text.secondary" mb={3}>
          This role is currently assigned to {userCount} users. Deleting it will remove all
          associated permissions.
        </Typography>

        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={onClose} sx={{ borderRadius: '25px', px: 3 }}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            sx={{ borderRadius: '25px', px: 3 }}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default DeleteRoleConfirmModal;
